import React from 'react';

import type { IStyle } from 'fela';
import type { RefObject } from 'react';

import { Box } from '../box/box';

type ReactInputProps = React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;

interface InputProps extends Omit<ReactInputProps, 'style' | 'ref'> {
  style?: IStyle;
  forwardedRef?: RefObject<HTMLInputElement | null>;
}

const Input = (props: InputProps) => <Box<InputProps, HTMLInputElement> as="input" {...props} />;

export default Input;
